import styled from "styled-components";
import { DesignTokens } from "melco-ui";

const { spacings } = DesignTokens;

export const CanvasWorkingArea = styled.div`
  position: relative;

  flex-grow: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${spacings.xlarge}px;
  img {
    width: 100%;
  }
`;
